import { ActionTree } from 'vuex'
import { Auth } from './types'
import { RootState } from '../types'
import {
  magentaOAuth,
  connectionService,
  SECURE_WS_URI,
  WAMP_REALM_URI,
  PERSON_FETCH_URI,
  ConnectionWSShared,
  wampUtils
} from '@leapsight/styleguide'
import store from '@/store'
import router from '@/router'
import PersonsHelpers from '@/helpers/persons/personsHelpers'

export const actions: ActionTree<Auth, RootState> = {
  checkTokenIsActive({ commit }) {
    return new Promise((resolve, reject) => {
      //Existe token?
      const token = localStorage.getItem('ACCESS_TOKEN')
      //Valido que este activo
      if (token) {
        magentaOAuth
          .active()
          .then(response => {
            commit('tokenValid', response)
            resolve(response)
          })
          .catch(err => {
            console.log('error ', err)
            reject()
          })
      } else {
        resolve(false)
      }
    })
  },

  async logout({ state, commit }) {
    try {
      const res = await magentaOAuth.logout()
      if (res.status === 200) {
        const connection = state.connection
        if (Boolean(connection)) ConnectionWSShared.closeConnection()
        commit('logout')
        await router.go(-1)
      }
    } catch (err) {
      console.log(err)
    } finally {
      commit('setDisconnectDialogValue', false)
    }
  },

  getConnection({ commit }, { fnConnOnOpen, fnConnOnClose }) {
    const conn = ConnectionWSShared.getInstance({ fnConnOnOpen, fnConnOnClose })
      .connection
    commit('setConnection', conn)
  },

  establishConnection({ state, commit, dispatch }) {
    const fnConnOnOpen = async session => {
      dispatch('wsConnectionActive', true)
      dispatch('setSession', session)
      await dispatch('personAccountFetch')

      dispatch('subscribeUserUpdated', () => {
        wampUtils.TokenServices.clearToken()
        commit('setDisconnectDialogValue', true, { root: true })
        setTimeout(() => dispatch('logout'), 10000)
      })
    }

    const fnConnOnClose = (reasons, details) => {
      console.log('Close connection')
      const reason = details.reason
      if (wampUtils.isReasonToDisconnect({ reason })) {
        wampUtils.TokenServices.clearToken()
        commit('setDisconnectDialogValue', true)
        setTimeout(() => dispatch('logout'), 10000)
      } else {
        dispatch('logout')
      }
    }

    if (state.connection?.session?.isOpen)
      fnConnOnOpen(state.connection.session)
    else {
      ConnectionWSShared.closeConnection()
      dispatch('getConnection', { fnConnOnOpen, fnConnOnClose })
    }
    
  },
  wsConnectionActive({ commit }, payload) {
    commit('wsConnectionActive', payload)
  },
  setSession({ commit }, payload) {
    commit('setSession', payload)
  },
  async personAccountFetch({ commit }) {
    const userId = connectionService.getBusinessUserId()
    const personData = await PersonsHelpers.personFetch({ userId })

    // Se verifica que el usuario logueado sea Administrador
    const userGroups = personData.kwargs.security.groups
    let userIsAdmin = false
    if (userGroups.includes('business_account_admin')) {
      userIsAdmin = true
    } else {
      userIsAdmin = false
    }
    const user = {
      id: personData.args[0].id,
      first_name: personData.args[0].first_name,
      last_name: personData.args[0].last_name,
      username: personData.args[0].roles['mrn:party_role:user'].username,
      isAdmin: userIsAdmin,
      photo: personData.args[0].photo,
      hasScheduledReportRole: connectionService.getAccountId() && (!process.env.VUE_APP_SCHEDULABLE_REPORT_ACCESS || process.env.VUE_APP_SCHEDULABLE_REPORT_ACCESS.trim().length == 0
          ||  process.env.VUE_APP_SCHEDULABLE_REPORT_ACCESS.indexOf(connectionService.getAccountId()) >= 0),
    }
    commit('setUser', user, { root: true })
  },

  subscribeUserUpdated({ getters }, callback) {
    const connection = getters['connection']
    const accountId = wampUtils.getAccountUUID(connectionService.getAccountId())
    const personId = wampUtils.getPersonUUID(connectionService.getBusinessUserId())
    return new Promise<void>(resolve => {
      const topic = `com.magenta.account.${accountId}.user.${personId}.updated`
      connection.session
        .subscribe(topic, callback, { match: 'exact' })
        .then(() => {
          resolve()
        })
    })
  }

}
